import React from "react";
import { CognitoLoginPage as SharedCognitoLoginPage } from "frontend/src/components/CognitoAuth";
import config from "Config/config";

export const CognitoLoginPage: React.FC = () => {
  return (
    <SharedCognitoLoginPage
      graphqlUri={config.RCG_GRAPHQL_URI()}
      title="Sign In to Sirius"
      subtitle="Enter your email to continue"
      logoUrl="/sirius_logo.jpg"
    />
  );
};
